import React from "react";
import styles from "./Tabs.module.css";
import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";

const TabsNav = ({ children, className, tabType = "pill" }) => {
  const tabsClasses = classNames({
    [styles.tabs]: true,
    [styles.pill]: tabType === "pill",
    [styles.underline]: tabType === "underline",
  });

  return <nav className={`${tabsClasses} ${className}`}>{children}</nav>;
};

const TabNav = ({ to, children, defaultRoute = "" }) => {
  const location = useLocation();
  const currentRoute = location.pathname;
  const tabClasses = classNames(styles.tab, {
    [styles.tabSelected]: currentRoute === to,
  });
  return (
    <Link to={to} className={tabClasses}>
      {children}
    </Link>
  );
};

export { TabsNav, TabNav };
